import { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import NewsletterData from "../../data/elements/newsletter.json";

const Odometer = dynamic(() => import("react-odometerjs"), {
  ssr: false,
  loading: () => 0,
});

const NewsletterTwo = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ type: "", text: "" });
      }, 5000); 

      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setMessage({ type: "", text: "" });

    if (!email.trim()) {
      setMessage({ type: "error", text: "Please enter your email address" });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage({ type: "error", text: "Please enter a valid email address" });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email.trim(),
          source: "newsletter"
        }),
      });

      const data = await response.json();

      if (data.ok) {
        setMessage({ 
          type: "success", 
          text: data.message || "Successfully subscribed to our newsletter!" 
        });
        setEmail("");
      } else {
        setMessage({ 
          type: "error", 
          text: data.message || "Failed to subscribe. Please try again." 
        });
      }
    } catch (error) {
      console.error("Error subscribing:", error);
      setMessage({ 
        type: "error", 
        text: "Network error. Please check your connection and try again." 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="row row--15 align-items-center">
        <div className="col-lg-12">
          {NewsletterData &&
            NewsletterData.newsletterTwo.map((data, index) => (
              <div className="inner text-center" key={index}>
                <div className="section-title text-center">
                  <span className="subtitle bg-white-opacity">
                    {data.subTitle}
                  </span>
                  <h2 className="title color-white">
                    <strong>{data.strong}</strong> {data.title}
                  </h2>
                  <p className="description color-white mt--20">{data.desc}</p>
                </div>

                <form onSubmit={handleSubmit} className="newsletter-form-1 mt--40">
                  <input 
                    type="email" 
                    placeholder="Enter Your E-Mail" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                  />
                  <button
                    type="submit"
                    className="rbt-btn btn-md btn-gradient hover-icon-reverse"
                    disabled={loading}
                  >
                    <span className="icon-reverse-wrapper">
                      <span className="btn-text">
                        {loading ? "Subscribing..." : "Subscribe"}
                      </span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                    </span>
                  </button>
                </form>

                <div className="message-wrapper mt--20">
                  {message.text && (
                    <div className={`alert-message ${message.type}`}>
                      <span className={`color-${message.type === "success" ? "white" : "danger"}`}>
                        {message.text}
                      </span>
                    </div>
                  )}
                </div>

                <span className="note-text color-white mt--20">
                  {data.text}
                </span>

                <div className="row row--15 mt--50">
                  {data.body.map((item, innerIndex) => (
                    <div
                      className={`col-lg-3 col-sm-6 col-md-6 single-counter ${
                        item.offset ? "offset-lg-3" : "single-counter"
                      }`}
                      key={innerIndex}
                    >
                      <div className="rbt-counterup rbt-hover-03 style-2 text-color-white">
                        <div className="inner">
                          <div className="content">
                            <h3 className="counter color-white">
                              <span className="odometer">
                                <Odometer value={item.num} />
                              </span>
                            </h3>
                            <h5 className="title color-white">{item.title}</h5>
                            <span className="subtitle color-white">
                              {item.subTitle}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </div>

      <style jsx>{`
        .message-wrapper {
          min-height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .alert-message {
          padding: 10px 20px;
          border-radius: 5px;
          display: inline-block;
          animation: slideIn 0.3s ease-out;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .alert-message.success {
          background-color: rgba(40, 167, 69, 0.2);
          border: 1px solid rgba(40, 167, 69, 0.5);
        }
        .alert-message.error {
          background-color: rgba(220, 53, 69, 0.2);
          border: 1px solid rgba(220, 53, 69, 0.5);
        }
        .color-danger {
          color: #ff6b6b !important;
        }
      `}</style>
    </div>
  );
};

export default NewsletterTwo;